import sv from "../locales/sv/cookieConsent.json";
import en from "../locales/en/cookieConsent.json";
import { getLanguage, type Language } from "@/utils/languageUtils";

export const cookieConsentLabels = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === "en" ? en : sv;
};
